const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    product_id: {
      type: 'string',
      title: 'محصول',
    },
    shop_id: {
      type: 'string',
      title: 'فروشگاه',
    },
    booth_id: {
      title: 'غرفه',
      type: 'string',
    },
    co_price: {
      type: 'number',
      title: 'قیمت کارخانه',
    },
    me_price: {
      type: 'number',
      title: 'قیمت فروشگاه',
    },
    unit_fie_id: {
      type: 'string',
      title: 'واحد محصول',
    },
    stock: {
      type: 'number',
      title: 'موجودی',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
    max_number_buy: {
      type: 'number',
      default: 5,
      minimum: 0,
      title: 'حداکثر تعداد قابل خرید',
    },
    nonexistent_number: {
      type: 'number',
      default: 5,
      minimum: 0,
      title: 'حداقل تعداد ناموجودی',
    },
    details: {
      type: 'string',
      title: 'توضیحات',
    },
  },
});

export default schema;
